import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgTimeInterruption = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M15.82 18.252a7.3 7.3 0 1 1 2.718-9.599s.523.596 1.134.224c.611-.373.376-1.005.376-1.005a9 9 0 1 0-3.39 11.86s.662-.446.276-1.134c-.385-.688-1.114-.346-1.114-.346"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M12.048 7.5c.468 0 .844.376.844.844V12c0 .225-.088.44-.246.598l-2.531 2.53a.843.843 0 0 1-1.192-1.192l2.285-2.284V8.344c0-.468.376-.844.844-.844zM20.952 10.985a.86.86 0 1 1-1.719 0 .86.86 0 0 1 1.719 0M20.81 14.26a.86.86 0 1 1-1.718 0 .86.86 0 0 1 1.719 0M19.294 17.18a.86.86 0 1 1-1.719 0 .86.86 0 0 1 1.719 0"
    }));
export default SvgTimeInterruption;
